import { SignalRCore } from "./core";
import { hubs } from "./config";

export class ProjectAssistantHub extends SignalRCore {
  constructor(token) {
    super();
    this.build(hubs.projectAssistant, token);
  }
}

/**
 * Defines the events for a project.
 *
 * @template T
 * @typedef {Object} ProjectEvents<T>
 * @property {string} usersOnProjectChanged - The event that is triggered when the users on the project change.
 * @property {string} leftProject - The event that is triggered when a user leaves the project.
 * @property {string} leaveProject - The event that is triggered when a user leaves the project.
 * @property {string} joinProject - The event that is triggered when a user joins the project.
 * @property {string} [projectSyncMessage] - The event that is triggered when a project sync message is received.
 * @property {string} [projectChanged] - The event that is triggered when the project changes.
 */

/**
 * @type {ProjectEvents<Object>}
 */
export const ProjectAssistantHubLines = {
  joinProject: "JoinProject",
  usersOnProjectChanged: "UsersOnProjectChanged",
  leftProject: "LeftProject",
  leaveProject: "LeaveProject",

  projectChanged: "ProjectChanged",
  projectSyncMessage: "ProjectSyncMessage",
};

/**
 * @type {ProjectEvents<Object>}
 */
export const DepartmentHubLines = {
  leaveProject: "LeaveDepartmentView",
  joinProject: "JoinDepartmentView",
  usersOnProjectChanged: "UsersOnDepartmentViewChanged",
  leftProject: "LeftDepartmentView",
};
